import { Box, Button, Checkbox, Collapse, IconButton, Radio, TableCell, TableRow, Theme, Typography, useTheme } from "@mui/material"
import { ColorMap, SwitchNavigationProps, TableBodyData, TableHeaderData } from "../../types"
import { checkImageExists, formatCurrency, toINR } from "../../../../utils/utilityFunctions"
import { BlackRightArrowIcons, CheckIcon, UnCheckIcon } from "../../../../assets/SvgIcons"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { QuantitativeAnalysisData } from "../../../../redux-store/types/products"
import { SwitchSchemeObj } from "../../../../redux-store/types/investmentdetails"
import { useSelector } from "react-redux"
import { RootStateType } from "../../../../redux-store/reducers"
import { HoldingsTableData } from "../holdings/types"


const colorMap: ColorMap = {
    profit: "success.500",
    loss: "error.500"
}


export const tableHeaderData: TableHeaderData[] = [
    {
        id: "categoryType",
        label: "CATEGORY",
        align: "left",
        isSortable: false
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "release",
        label: "REALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "dividend",
        label: "DIVIDEND",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
    {
        id: "ACTIONS",
        label: "ACTIONS",
        align: "center",
        isSortable: true
    },
]
export const AmctableHeaderData: TableHeaderData[] = [
    {
        id: "amcname",
        label: "AMC NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "holding",
        label: "HOLDING",
        align: "center",
        isSortable: true
    },
    {
        id: "equity",
        label: "EQUITY",
        align: "center",
        isSortable: true
    },
    {
        id: "debt",
        label: "DEBT",
        align: "center",
        isSortable: true
    },
    {
        id: "hybrid",
        label: "HYBRID",
        align: "center",
        isSortable: true
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
]

export const InvestorLevelAmctableHeaderData: TableHeaderData[] = [
    {
        id: "amcname",
        label: "AMC NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "holding",
        label: "HOLDING ",
        align: "center",
        isSortable: true
    },

    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "release",
        label: "REALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "dividend",
        label: "DIVIDEND",
        align: "center",
        isSortable: true
    },
    {
        id: "unRelease",
        label: "UNREALISED GAIN/LOSS",
        align: "center",
        isSortable: true
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: true
    },
]
export const HoldingModalTableHead: TableHeaderData[] = [
    {
        id: "SCHEME",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    {
        id: "Unit",
        label: "UNIT",
        align: "center",
        isSortable: true
    },
    {
        id: "INVESTEDVALUE",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "MARKETVALUE",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "UNREALISEDGAIN/LOSS",
        label: "UNREALISED GAIN/LOSS(%)",
        align: "center",
        isSortable: true
    },
    {
        id: "IRR",
        label: "ABSOLUTE RETURN %",
        align: "center",
        isSortable: true
    },
]
export const TopSchemeTableHead: TableHeaderData[] = [
    {
        id: "scheme",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    // {
    //     id: "sector",
    //     label: "SECTOR",
    //     align: "center",
    //     isSortable: true
    // },
    {
        id: "amount",
        label: "AMOUNT",
        align: "center",
        isSortable: false
    },
    {
        id: "exposure",
        label: "EXPOSURE",
        align: "center",
        isSortable: false
    },
]
export const QuantitativeAnalysisHead: TableHeaderData[] = [
    {
        id: "metric",
        label: "METRIC",
        align: "left",
        isSortable: false
    },
    {
        id: "value",
        label: "VALUE",
        align: "center",
        isSortable: false
    },
]



export const CategoryTableBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const theme = useTheme()
    const history = useHistory();
    const pathName = history?.location?.pathname;

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const handleArrowClick = (category: string) => {
        history.push(`${pathName}/category-wise-breakup`, { category, clientCode })
    }

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                const realisedGainLossPerc = calculatePercentage(obj?.release, obj?.investedValue)
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)

                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.categoryType}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.release >= 0 && obj?.marketValue >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.release < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.release), locale, currencyCode })}` : `${formatCurrency({ value: obj?.release, locale, currencyCode })}`} ({realisedGainLossPerc})
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.dividend}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.unRelease >= 0 && obj?.marketValue >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.unRelease < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unRelease), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unRelease, locale, currencyCode })}`} ({unRealisedGainLossPerc})
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.irr && (obj?.irr).toFixed(2)}%
                            </Typography>
                        </TableCell>

                        <TableCell align="center">
                            {obj?.categoryType !== "Others" &&
                                <IconButton onClick={() => handleArrowClick(obj?.categoryType)}>
                                    <BlackRightArrowIcons />
                                </IconButton>
                            }
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}
export const AmcTableBody = (
    {
        tableBodyData,
        handleCheckboxClick
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500],
                                    },
                                    fontSize: '16px',
                                    // textWrap: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                })}
                            >
                                {obj?.amcname}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.holding && `${(obj?.holding).toFixed(2)}%`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.equity && `${(obj?.equity).toFixed(2)}%`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.debt && `${(obj?.debt).toFixed(2)}%`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.hybrid && `${(obj?.hybrid).toFixed(2)}%`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.unRelease >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.unRelease < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unRelease), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unRelease, locale, currencyCode })}`}{`(${unRealisedGainLossPerc})`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.irr && `${(obj?.irr).toFixed(2)}%`}
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}

export const InvestorLevelAmcTableBody = (
    {
        tableBodyData,
        handleCheckboxClick
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {
                const unRealisedGainLossPerc = calculatePercentage(obj?.unRelease, obj?.investedValue)
                const realizedGainLossPerc = calculatePercentage(obj?.release, obj?.investedValue)
                return (
                    <TableRow
                        key={obj?.id}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    // textWrap: 'nowrap', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {obj?.amcname}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.holding && (obj?.holding).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.equity).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.debt).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.hybrid).toFixed(2)}%
                            </Typography>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.release >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.release < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.release), locale, currencyCode })}` : `${formatCurrency({ value: obj?.release, locale, currencyCode })}`}{`(${realizedGainLossPerc})`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.dividend}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.unRelease >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.unRelease < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.unRelease), locale, currencyCode })}` : `${formatCurrency({ value: obj?.unRelease, locale, currencyCode })}`}{`(${unRealisedGainLossPerc})`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.irr >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.irr?.toFixed(2)}%
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}

export const HoldingModalTableBody = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue
    }: any
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const { palette } = useTheme()

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj.id}
                    sx={{
                        // '& td': {
                        //     paddingTop: "20px",
                        //     paddingBottom: "15px",
                        //     borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                        //     ':first-of-type': {
                        //         paddingLeft: "0px",
                        //     }
                        // },
                    }}
                >
                    <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                            <Radio size="small" onChange={() => handleRatioClick(obj.id)} checked={radioValue === obj.id} />
                            {obj?.mutualfund.image &&
                                <img src={obj?.mutualfund.image} width={'50px'} height={'50px'} alt="Bank name" style={{ borderRadius: '8px 8px 8px 8px' }} />
                            }
                            <Box >
                                <Typography variant='body_500' color="text.primary"> {obj?.mutualfund.name || ''}</Typography>
                                <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                    <Typography variant='body_400' color={palette.text.secondary}>{obj?.mutualfund.type || ''}</Typography>
                                    <Typography variant='body_400' color={palette.text.secondary}>• {obj?.mutualfund.cap || ''}</Typography>
                                    <Typography variant='body_400' color={palette.success[500]}>• {obj?.mutualfund.risk || ''}</Typography>
                                </Box>
                            </Box>

                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap'
                            })}
                        >
                            {obj.unit}%
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap'
                            })}
                        >
                            {toINR({ value: obj.invested, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textTransform: 'capitalize',
                                textWrap: 'nowrap'
                            })}
                        >
                            {toINR({ value: obj.market, locale, currencyCode })}%
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {toINR({ value: obj.unrealised, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {obj.irr}
                        </Typography>
                    </TableCell>

                </TableRow>
            ))}
        </>
    )
}
export const SwitchTableBody = (
    {
        tableBodyData,
        handleProcess,
        handleSchemeChange,
        selectedScheme,
        currentData,
        isSwitchScreen

    }: { tableBodyData: SwitchSchemeObj[], handleProcess: any, handleSchemeChange: (item: any) => void, selectedScheme: string, currentData: { itemData: HoldingsTableData }, isSwitchScreen: boolean }
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const { palette, typography } = useTheme()

    return (
        <>
            {tableBodyData?.map((obj: SwitchSchemeObj) => {
                const transactionAllowed = isSwitchScreen ? `${obj?.switchAllowed ?? ""}`?.toLowerCase() === 'y' : true

                return (
                    <React.Fragment key={obj?.scheme}>
                        <TableRow>
                            <TableCell align="left" style={{ borderBottom: 0, opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'row', gap: '15px', cursor: 'pointer', }}>
                                    <Radio
                                        onChange={handleSchemeChange}
                                        disabled={currentData?.itemData?.schemeId === obj?.scheme}
                                        checked={selectedScheme == obj?.scheme}
                                        value={obj?.scheme}
                                        inputProps={{ 'aria-label': obj?.scheme }}
                                        size="small"
                                        sx={{
                                            paddingLeft: 0,
                                        }} />
                                    <Box >
                                        <Typography variant='body_500' fontSize={16} color="text.primary"> {obj?.schemeName || ''}</Typography>
                                        <Box sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            // flexWrap: 'wrap',
                                            marginTop: '12px',
                                            gap: '5px',
                                            // background: 'red',
                                        }}>
                                            <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                            <Typography variant='body_400' color={palette.text.secondary} sx={{
                                                whiteSpace: 'nowrap',
                                                maxWidth: '180px',
                                                display: 'inline-block',
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden'
                                            }}> • {obj?.subCategoryName || ''}</Typography>
                                            {obj?.riskType !== 'NULL' &&
                                                <Typography variant='body_400' color={palette.success[500]} sx={{ flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>• {obj?.riskType || ''}</Typography>
                                            }
                                        </Box>
                                        <Box sx={{ marginTop: "3px" }}>
                                            <Typography
                                                variant="body_400"
                                                color="text.primary"
                                            >
                                                ISIN:{' '}
                                                <Typography
                                                    component="span"
                                                    variant="body_400"
                                                    color="text.secondary"
                                                >
                                                    {obj?.isinCode ?? ""}
                                                </Typography>
                                            </Typography>
                                        </Box>

                                    </Box>
                                </Box>
                            </TableCell>
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {obj?.year1Return?.toFixed(2)}%
                                </Typography>
                            </TableCell>
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {/* {toINR({ value: obj?.year3Return, locale, currencyCode })} */}
                                    {obj?.year3Return?.toFixed(2)}%
                                </Typography>
                            </TableCell>
                            <TableCell align="center" style={{ borderBottom: 0 }}>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        textTransform: 'capitalize',
                                        textWrap: 'nowrap',
                                        opacity: currentData?.itemData?.schemeId === obj?.scheme ? .5 : 1
                                    })}
                                >
                                    {/* {toINR({ value: obj?.year5Return, locale, currencyCode })}% */}
                                    {obj?.year5Return?.toFixed(2)}%
                                </Typography>
                            </TableCell>

                        </TableRow>
                        <TableRow key={obj?.scheme + '-collapse'}>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderTop: 0 }} colSpan={4}>
                                <Collapse in={selectedScheme == obj?.scheme} timeout="auto" unmountOnExit >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '15px' }}>
                                        {
                                            !transactionAllowed ?
                                                <Typography variant="body_600" color={palette.error[500]}>
                                                    Switch transaction not allowed
                                                </Typography> : null

                                        }

                                        <Box component={'button'}
                                            disabled={!transactionAllowed}
                                            onClick={() => handleProcess(obj?.scheme, obj?.divReinvestAllowed)}
                                            style={{
                                                background: palette.primary[500],
                                                borderRadius: '10px',
                                                border: 'none',
                                                color: palette.textDark.primary,
                                                fontFamily: typography.fontFamily,
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                width: "100%",
                                                maxWidth: '216px',
                                                padding: '10px 0',
                                                marginBottom: '15px',
                                                cursor: !transactionAllowed ? 'not-allowed' : 'pointer',
                                                opacity: !transactionAllowed ? .5 : 1

                                            }}>Proceed</Box>
                                    </Box>
                                </Collapse>
                            </TableCell>
                        </TableRow>
                    </React.Fragment>
                )
            })}
        </>
    )
}


export const InvestmentSearchTable = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue,
        selectedSchemesIds
    }: any
): JSX.Element => {
    const { palette } = useTheme()
    // console.log('radioValue', radioValue)
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {
                const amcIds = ['BDOTR', 'BPIAMC']
                const checkAmcId = amcIds.includes(obj.company ?? '') ? obj.company?.toLowerCase() : obj.company;
                return (
                    <TableRow
                        key={obj?.scheme}
                    >
                        <TableCell align="left">
                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                                <Checkbox size="small"
                                    onChange={() => handleRatioClick(obj)}
                                    checkedIcon={<CheckIcon />}
                                    icon={<UnCheckIcon />}
                                    checked={radioValue.some((el: any) => (el?.scheme || el as string) === obj?.scheme)} sx={{ padding: '0px' }} />
                                <img src={checkImageExists(`${checkAmcId}`) ? `../../../../../../../images/amcIcons/${checkAmcId}.svg` : `../../../../../../../images/amcIcons/default.svg`}
                                    width={'50px'} height={'50px'} alt="fund name" style={{
                                        borderRadius: '8px 8px 8px 8px',
                                    }} />
                                <Box >
                                    <Typography variant='body_500' color="text.primary" > {obj?.schemeName || ''}</Typography>
                                    <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                        <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                        <Typography variant='body_400' color={palette.text.secondary}>• {obj?.subCategoryName || ''}</Typography>
                                        {obj?.riskType !== "NULL" &&
                                            <Typography variant='body_400' color={palette.success[500]}>• {obj?.riskType || ''}</Typography>
                                        }
                                    </Box>
                                    <Box sx={{ marginTop: "3px" }}>
                                        <Typography
                                            variant="body_400"
                                            color="text.primary"
                                        >
                                            ISIN:{' '}
                                            <Typography
                                                component="span"
                                                variant="body_400"
                                                color="text.secondary"
                                            >
                                                {obj?.isinCode ?? ""}
                                            </Typography>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year1Return ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year3Return ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    textTransform: 'capitalize',
                                    textWrap: 'nowrap',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                })}
                            >
                                {obj?.year5Return ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%'}
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{ textWrap: 'nowrap' }}
                            >
                                {obj.irr}
                            </Typography>
                        </TableCell> */}

                    </TableRow>
                )
            })}
        </>
    )
}

export const HoldingSearchFundTable = (
    {
        tableBodyData,
        handleRatioClick,
        radioValue,
        selectedSchemesIds
    }: any
): JSX.Element => {
    const { palette } = useTheme()
    // console.log('radioValue', radioValue)

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj?.scheme}
                >
                    <TableCell align="left">
                        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', cursor: 'pointer', maxWidth: "453px", background: 'red.' }}>
                            <Checkbox size="small"
                                onChange={() => handleRatioClick(obj)}
                                checkedIcon={<CheckIcon />}
                                icon={<UnCheckIcon />}
                                // disabled={selectedSchemesIds?.includes(obj?.scheme)}
                                checked={radioValue.some((el: any) => (el?.scheme || el as string) === obj?.scheme)} sx={{ padding: '0px' }} />
                            {/* {obj?.mutualfund.image && */}
                            <img src={'https://s3-alpha-sig.figma.com/img/b881/5771/80648be305b04aee802e2983ee32eb71?Expires=1713139200&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=Jm9LVFjpGg~9XKP1l3XSB8dPbLVZBXttKfjD9TpcXqRN4F9wX0oeUa1NWC8xRRT53oMGROUqfbxsR8B-s2mr7lzBeyIrHr4Bvm-zyyMWilFMEuIq-BIH5NoNZWM3IhNSPR8tb0ZAOO33KMeR0FwF~cDj1nwAWTk0MMmwf20p3109y8ixN~Z643ap3G1ERoLzM6YRBTyRfP7hsOy2wCh4WOA1aDMSvuLAEsfXaO2PSck2iet6aaJ67ZIHOl6SOpJfckePZMh17eEBaUEpVAkWBZuEFvvZWoDxPjuiSsk3rmu8oRk5ohI-FbBprcubGK2oYuYiMWYv0e8VcRden8YwZw__'}
                                width={'50px'} height={'50px'} alt="fund name" style={{
                                    borderRadius: '8px 8px 8px 8px',
                                    // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                                }} />
                            {/* } */}
                            <Box >
                                <Typography variant='body_500' color="text.primary" > {obj?.schemeName || ''}</Typography>
                                <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                                    <Typography variant='body_400' color={palette.text.secondary}>{obj?.categoryName || ''}</Typography>
                                    <Typography variant='body_400' color={palette.text.secondary}>• {obj?.subCategoryName || ''}</Typography>
                                    {obj?.riskType !== "NULL" &&
                                        <Typography variant='body_400' color={palette.success[500]}>• {obj?.riskType || ''}</Typography>
                                    }
                                </Box>
                            </Box>

                        </Box>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year1Return ? `${Number(obj?.year1Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year3Return ? `${Number(obj?.year3Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textTransform: 'capitalize',
                                textWrap: 'nowrap',
                                // opacity: selectedSchemesIds?.includes(obj?.scheme) ? 0.5 : 1
                            })}
                        >
                            {obj?.year5Return ? `${Number(obj?.year5Return).toFixed(2)}%` : '0%'}
                        </Typography>
                    </TableCell>
                    {/* <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{ textWrap: 'nowrap' }}
                        >
                            {obj.irr}
                        </Typography>
                    </TableCell> */}

                </TableRow>
            ))}
        </>
    )
}

export const TopSchemTable = (
    {
        tableBodyData,
    }: any
): JSX.Element => {
    const theme = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => {

                const folioCheck = obj?.folioNo === '0' ? '' : `(${obj?.folioNo})`
                return (
                    <TableRow
                        key={obj?.id}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },

                                    fontSize: '16px',
                                })}
                            >
                                {`${obj?.schemeName}${folioCheck}`}
                            </Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.sector}
                            </Typography>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.amount < 0 ? `- ${formatCurrency({
                                    value: Math.abs((obj?.amount)), locale, currencyCode
                                })}` : `${formatCurrency({ value: obj?.amount, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.exposure?.toFixed(2)}%
                            </Typography>
                        </TableCell>

                    </TableRow>
                )
            })}
        </>
    )
}
export const QuantitativeAnalysisTable = (
    { tableBodyData, selectedTab }: { tableBodyData: Array<QuantitativeAnalysisData>, selectedTab: string }
): JSX.Element => {
    const theme = useTheme()
    const avoidAmcNames = ['average maturity', 'duration', 'ytm']

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj?.id}
                    sx={{
                        '& td': {
                            paddingTop: "20px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            ':first-of-type': {
                                paddingLeft: "0px",
                            }
                        },
                    }}
                > {(selectedTab?.toLowerCase() === "equity" || selectedTab?.toLowerCase() === "hybrid") ? (
                    !avoidAmcNames.includes(obj?.amcname?.toLowerCase()) && (
                        <>
                            <TableCell align="left" >
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        '&:hover': {
                                            color: theme.palette.primary[500]
                                        },
                                        fontSize: '16px',
                                    })}
                                >
                                    {obj?.amcname ?? '-'}
                                </Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.primary,
                                        fontSize: '16px',
                                    })}
                                >
                                    {/* {!Number.isNaN(Number(obj?.holding ?? 0)) ?
                                        Math.round((obj?.holding ?? 0) * 100) / 100 : '0'} */}
                                    {!Number.isNaN(Number(obj?.holding ?? 0)) ?
                                        (obj?.holding ?? 0).toFixed(2) : '0'}
                                </Typography>
                            </TableCell>
                        </>
                    )
                ) : (
                    <>
                        <TableCell align="left" >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    textTransform: 'capitalize',
                                    fontSize: '16px',
                                })}
                            >
                                {(obj?.amcname) ?? '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {/* {!Number.isNaN(Number(obj?.holding ?? 0)) ?
                                    Math.round((obj?.holding ?? 0) * 100) / 100 : '0'} */}
                                {!Number.isNaN(Number(obj?.holding ?? 0)) ?
                                    (obj?.holding ?? 0).toFixed(2) : '0'}
                            </Typography>
                        </TableCell>
                    </>

                )}
                </TableRow>
            ))}
        </>
    )
}